import { Instance, types } from 'mobx-state-tree'
import { ForDirectExtend } from '../../../../features/mobx'
import { DrumLoopStore } from './DrumLoopStore'
import { MelodicLoopStore } from './MelodicLoopStore'

// Either a reference to a fully defined MelodicLoop, a DrumsLoop, or a remixed loop.
const _LoopRefStore = types
  .model({
    melodicLoop: types.optional(MelodicLoopStore, {}),
    drumLoop: types.optional(DrumLoopStore, {})
  })
  .views((self) => ({}))
  .actions((self) => {
    function afterCreate() {}
    function setMelodicLoop(melodicLoop) {
      self.melodicLoop = melodicLoop
    }
    function setDrumLoop(drumLoop) {
      self.drumLoop = drumLoop
    }
    return {
      afterCreate,
      setMelodicLoop,
      setDrumLoop
    }
  })

interface LoopRefStoreType extends ForDirectExtend<typeof _LoopRefStore> {}
export const LoopRefStore: LoopRefStoreType = _LoopRefStore

export interface ILoopRefStore extends ForDirectExtend<Instance<typeof LoopRefStore>> {}
